import { SxProps, Theme } from '@mui/material';

export const helpButtonStyles: SxProps<Theme> = {
  position: 'absolute',
  top: 0,
  right: 0,
  zIndex: 1,
};
